<template>
  <Photos year="2017" :min-date="1497225600" :max-date="1497744000" date-text="June 14&ndash;16" />
</template>

<script setup>
import Photos from "@/components/Photos.vue";
</script>
